import * as React from "react";
import Head from "next/head";
import Footer from "../components/Footer";
import Layout from "../components/Layout";
import Header from "../components/Header";
import ContactUs from "../components/ContactUs";

export default function IndexRoute() {
  return (
    <>
        <Head>
            <title>TacBoard Contact Us: We&#39;re always happy to help.</title>
            <meta name="description" content="If you have any questions about TacBoard or about Event or wedding photo booth alternatives please reach out to us. We are always happy to help." />
            <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Aleo:200,300,400,700|Montserrat:300,400,500,700" />
           <link rel="canonical" href="https://tacboard.com/contact-us" />
        </Head>

      <Layout classes={["contact-us", "public"]}>
        <Header />
        <ContactUs />
        <Footer />
      </Layout>
    </>
  );
};
